import { useState } from 'react';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import { ClickAwayListener } from '@mui/material';
import { twJoin, twMerge } from 'tailwind-merge';

export default function Popup({
  triggerEl,
  children,
  className,
  popperProps = {},
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      {triggerEl({ open, setOpen, anchorEl, setAnchorEl })}
      <Popper
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
        {...(typeof popperProps === 'function'
          ? popperProps({ open, setOpen, anchorEl, setAnchorEl })
          : popperProps)}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div
              className={twMerge(
                'bg-white rounded-lg shadow-popup overflow-hidden',
                twJoin(className?.root && className.root)
              )}
            >
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                {typeof children === 'function'
                  ? children({ open, setOpen, anchorEl, setAnchorEl })
                  : children}
              </ClickAwayListener>
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
}
